<template>
  <SimpleDictView
    endpoint="positions/"
    :title="$t('settings.titles.positions')"
    :add-button="$t('settings.addButtons.position')"
    :fields="fields"
  />
</template>

<script>
import SimpleDictView from './SimpleDictView.vue'
export default {
  name: 'PositionsView',
  components: { SimpleDictView },
  computed: {
    fields() {
      return [
        { key: 'name', label: this.$t('settings.fields.name'), placeholder: this.$t('settings.placeholders.positionName') },
        { key: 'code', label: this.$t('settings.fields.roleCode'), placeholder: this.$t('settings.placeholders.positionCode'), maxlength: 32 },
      ]
    },
  },
}
</script>
